import { LEGAL_DOCUMENTS, type LegalDocumentId, type LegalDocumentMeta as SharedLegalDocumentMeta } from '@tipi/shared'

import { LEGAL_DOCUMENT_MARKDOWN } from './legalContent'

export type LegalDocumentMeta = SharedLegalDocumentMeta & {
    contactEmail: string
}

export const LEGAL_CONTACT_EMAIL = 'management@oktipi.com'

const landingLegalDocuments: Record<LegalDocumentId, LegalDocumentMeta> = {
    terms: {
        ...LEGAL_DOCUMENTS.terms,
        contactEmail: LEGAL_CONTACT_EMAIL,
    },
    privacy: {
        ...LEGAL_DOCUMENTS.privacy,
        contactEmail: LEGAL_CONTACT_EMAIL,
    },
    cookies: {
        ...LEGAL_DOCUMENTS.cookies,
        contactEmail: LEGAL_CONTACT_EMAIL,
    },
    dpa: {
        ...LEGAL_DOCUMENTS.dpa,
        contactEmail: LEGAL_CONTACT_EMAIL,
    },
}

export const formatLegalPublishedDate = (isoDate: string) => {
    const date = new Date(`${isoDate}T12:00:00`)
    return new Intl.DateTimeFormat('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(date)
}

export const getLegalDocument = (documentId: LegalDocumentId) => ({
    ...landingLegalDocuments[documentId],
    markdown: LEGAL_DOCUMENT_MARKDOWN[documentId],
})
